import { createSelector } from 'reselect';
import { Action } from '@ngrx/store';

import * as actions from '../actions/statistics.actions';
import * as moment from 'moment-timezone';

export interface State {
  filters?: {
    dateFrom: Date;
    dateTo: Date;
  };
  customers: {
    loading: boolean;
    error?: any;
    data?: Array<{
      customerId: string;
      checkedIn?: number;
      memoCreated?: number;
      fileAdded?: number;
      assignedTeamMembers?: number;
    }>;
  };
  memos: {
    loading: boolean;
    data?: {
      total: number;
      categories: { [id: string]: number };
      types: { [type: string]: number };
      dates: { [date: string]: number };
    };
    error?: any;
  };
  members: {
    loading: boolean;
    error?: any;
    data?: Array<{
      memberId: string;
      checkedIn?: number;
      memoCreated?: number;
      fileAdded?: number;
    }>;
  };
  error?: string;
}

const initialState: State = {
  filters: {
    dateFrom: moment()
      .tz('Australia/Adelaide')
      .startOf('day')
      .subtract(30, 'days')
      .toDate(),
    dateTo: moment()
      .tz('Australia/Adelaide')
      .endOf('day')
      .toDate()
  },
  customers: {
    loading: false
  },
  memos: {
    loading: false
  },
  members: {
    loading: false
  }
};

export function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case actions.REQUEST_MEMO_STATISTICS:
      return { ...state, memos: { ...state.memos, loading: true } };

    case actions.RESPONSE_SUCCESS_MEMO_STATISTICS:
      return { ...state, memos: { loading: false, data: (<any>action).payload } };

    case actions.RESPONSE_FAIL_MEMO_STATISTICS:
      return { ...state, memos: { ...state.memos, loading: false, error: (<any>action).payload } };

    case actions.REQUEST_MEMBERS_STATISTICS:
      return { ...state, members: { ...state.members, loading: true } };

    case actions.RESPONSE_SUCCESS_MEMBERS_STATISTICS:
      return { ...state, members: { loading: false, data: (<any>action).payload } };

    case actions.RESPONSE_FAIL_MEMBERS_STATISTICS:
      return {
        ...state,
        members: { ...state.members, loading: false, error: (<any>action).payload }
      };

    case actions.REQUEST_CUSTOMERS_STATISTICS:
      return { ...state, customers: { ...state.customers, loading: true } };

    case actions.RESPONSE_SUCCESS_CUSTOMERS_STATISTICS:
      return { ...state, customers: { loading: false, data: (<any>action).payload } };

    case actions.RESPONSE_FAIL_CUSTOMERS_STATISTICS:
      return {
        ...state,
        customers: { ...state.customers, loading: false, error: (<any>action).payload }
      };

    default:
      return state;
  }
}

export const createSelectors = rootReducer => ({
  getCustomersStats: createSelector(rootReducer, (state: State) => state.customers),
  getFilters: createSelector(rootReducer, (state: State) => state.filters),
  getMemoStats: createSelector(rootReducer, (state: State) => state.memos),
  getMembersStats: createSelector(rootReducer, (state: State) => state.members),
  isMemoStatsLoading: createSelector(rootReducer, (state: State) => state.memos.loading)
});
